import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/shell/shell.js'
import 'codemirror/mode/go/go.js'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/powershell/powershell.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'

export default codemirror
